import React, { useState, useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import DateFnsUtils from "@date-io/date-fns";

// Material-UI Core
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";

// Material-UI Element
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";

// Custom Style
import { transAtthStyle } from "../../../../styles/jss/components/transmittal/transAtthStyle";

const useStyles = makeStyles((theme) => transAtthStyle(theme));
const TransimittalEditDocumentItem = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    submissionValue,
    setSubmissionValue,
    editRow,
    setEditRow,
    setSelectEditDialogOpen,
  } = props;

  const submissionTransmittalDetailRedux = useSelector(
    (state) => state.submissionTransmittalDetailRedux
  );
  const [validationErrors, setValidationErrors] = useState({});

  // Handle Input
  const handleInputChange = (name, validateOnChange) => (event) => {
    setEditRow({ ...editRow, [name]: event.target.value });
    if (validateOnChange) {
      validate({ ...editRow, [name]: event.target.value });
    }
  };

  const validate = (fieldValues = editRow) => {
    let temp = { ...setValidationErrors };

    if ("material" in fieldValues) {
      temp.material = fieldValues.material ? "" : "This field is required";
    }

    setValidationErrors({ ...temp });

    if (fieldValues == editRow) {
      return Object.values(temp).every((x) => x == "");
    }
  };

  //Handle Date
  const handleDateFieldChange = (date, name) => {
    const data = { ...editRow };

    data[name] = date;
    setEditRow({ ...editRow, ...data });
  };
  const saveEditedRow = () => {
    if (validate()) {
      let data = { ...submissionValue };
      const targetedIndex = submissionValue.documents.findIndex(
        (obj) => obj.id === editRow.id
      );
      data.documents[targetedIndex] = editRow;
      setSubmissionValue({ ...submissionValue, ...data });
      setSelectEditDialogOpen(false);
      dispatch({
        type: "ADD_TRANSMITTAL_SUBMISSION_VALUE",
        data: { ...submissionValue, ...data },
      });
    }
  };

  const isReadOnly =
    submissionValue.documents[
      submissionValue.documents.findIndex((obj) => obj.id === editRow.id)
    ].type === "rfi"
      ? true
      : false;

  return (
    <>
      <Fragment>
        <Grid item xs={12}>
          <Typography variant="subtitle1" className={classes.headerText}>
            {`Edit ${editRow.ref_no ? editRow.ref_no : ""}`}
          </Typography>
          <Divider className={classes.divider} />
          <Grid item xs={12}>
            <TextField
              className={classes.textField}
              fullWidth={true}
              required
              id={"material"}
              name={"material"}
              label={"Submission Material Type"}
              type="text"
              size="small"
              variant="outlined"
              value={editRow.material || ""}
              onChange={handleInputChange("material")}
              InputProps={{
                readOnly: isReadOnly,
                maxLength: 255,
              }}
              error={
                validationErrors.material && validationErrors.material !== ""
                  ? true
                  : false
              }
              helperText={validationErrors.material}
            />
          </Grid>
          <Divider className={classes.divider} />
          <Grid item xs={12}>
            <TextField
              className={classes.textField}
              fullWidth={true}
              id={"ref_no"}
              name={"ref_no"}
              label={"Ref No."}
              type="text"
              //	required={element.mandatory}
              size="small"
              variant="outlined"
              value={editRow.ref_no || ""}
              onChange={handleInputChange("ref_no")}
              InputProps={{
                readOnly: isReadOnly,
                maxLength: 255,
              }}
            />
          </Grid>
          <Divider className={classes.divider} />
          <Grid item xs={12}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                className={classes.textField}
                id={"date"}
                name={"atthDate"}
                label={"Date"}
                format="dd/MM/yyyy"
                placeholder="DD/MM/YYYY"
                size="small"
                fullWidth={true}
                inputVariant="outlined"
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
                className={classes.datePickerField}
                value={editRow.atthDate != null ? editRow.atthDate : null}
                onChange={(date) => handleDateFieldChange(date, "atthDate")}
                InputProps={{
                  readOnly: isReadOnly,
                  maxLength: 255,
                }}
                readOnly={isReadOnly}
              />
            </MuiPickersUtilsProvider>
          </Grid>
          <Divider className={classes.divider} />
          <Grid item xs={12}>
            <TextField
              className={classes.textField}
              fullWidth={true}
              id={"description"}
              name={"description"}
              label={"Description"}
              type="text"
              size="small"
              variant="outlined"
              value={editRow.description || ""}
              onChange={handleInputChange("description")}
            />
          </Grid>
          <Divider className={classes.divider} />
          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              className={classes.formBtn}
              onClick={saveEditedRow}
            >
              Save and Close
            </Button>
          </Grid>
        </Grid>
      </Fragment>
    </>
  );
};

export default TransimittalEditDocumentItem;
